const foto = [
    {
      id: "1",
      img:  "https://images.pexels.com/photos/700446/pexels-photo-700446.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      titolo: "BODYBUILDING"
    },
    {
      id: "2",
      img:"https://images.pexels.com/photos/791763/pexels-photo-791763.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      titolo: "POWERLIFTING"
      
    },
    {
      id: "3",
      img:"https://www.my-personaltrainer.it/2019/10/30/calisthenics_900x760.jpeg",
      titolo: "CALISTHENICS"
      
    },
  ];
  
  export default foto;